export default __webpack_public_path__ + "static/media/esophagus_plot_male.3691e3f6.png";